import { PollCard, type PollProps } from '@/components/poll/PollCard'
import { Button } from '@/components/ui/Button'
import { formatDateTime } from '@/utils/datetime/formatDate'
import type { Hex } from 'viem'
import { testIdFactory } from '@/utils/test-id-factory.ts'

interface AdminPollCardProps extends PollProps {
	address: Hex
	onPressDelete?: (address: Hex) => void
	onPressEdit?: (address: Hex) => void
	onPressDuplicate?: (address: Hex) => void
	loading?: boolean
}

export function AdminPollCard({
	onPressDelete,
	onPressEdit,
	onPressDuplicate,
	endDate,
	startDate,
	loading,
	className,
	...props
}: AdminPollCardProps) {
	const isUpcomingPoll = startDate > new Date()
	const isEndedPoll = endDate < new Date()

	return (
		<PollCard startDate={startDate} endDate={endDate} readonly {...props}>
			<div className="flex justify-between items-center gap-5">
				<div className="flex flex-col gap-2">
					<p className="text-[32px] font-pp-neue-bit font-bold leading-6 text-neutral-100">
						Start date: <span className="text-green-50">{formatDateTime(startDate.getTime())}</span>
					</p>
					<p className="text-[32px] font-pp-neue-bit font-bold leading-6 text-neutral-100">
						End date: <span className="text-green-50 ml-3">{formatDateTime(endDate.getTime())}</span>
					</p>
				</div>
				<div className="flex gap-5">
					{/* {isUpcomingPoll && (
						<Button
							variant="outline"
							className="py-5 px-10"
							loading={loading}
							onClick={() => onPressDelete?.(props.address)}
							data-testid={testIdFactory.adminPollDeleteModalButton()}
						>
							Delete
						</Button>
					)} */}
					{!isEndedPoll && (
						<Button
							variant="danger"
							className="py-5 px-10"
							loading={loading}
							onClick={() => onPressEdit?.(props.address)}
							data-testid={testIdFactory.adminPollUpdateModalButton()}
						>
							Edit
						</Button>
					)}
					{/* {isEndedPoll && (
						<Button
							variant="danger"
							className="py-5 px-10"
							loading={loading}
							onClick={() => onPressDuplicate?.(props.address)}
							data-testid={testIdFactory.adminPollDuplicateButton()}
						>
							Duplicate
						</Button>
					)} */}
				</div>
			</div>
		</PollCard>
	)
}
